import * as React from "react";
const ExitMenu = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.8076 14.2901L19.0003 10.0975L14.8076 5.90479"
      stroke="#FF6A4B"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M7.74219 10.0972L17.8843 10.0972"
      stroke="#FF6A4B"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M9.99219 19C5.01969 19 0.992188 15.625 0.992188 10C0.992188 4.375 5.01969 1 9.99219 1"
      stroke="#FF6A4B"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ExitMenu;